import React from 'react';
import { Grid, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { THEME } from '../../config';
import { StatisticsType } from './Statistics';

const useStyles = makeStyles(() => ({
  button: {
    width: '100%',
    justifyContent: 'flex-start',
    textAlign: 'left',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    boxShadow: '0',
    borderRadius: '0',
    color: 'inherit',
  },
  gridContainer: {
    borderRight: 'solid 2px #e0e0e0',
    position: 'sticky',
    top: 0,
  },
  gridActive: {
    borderLeft: `3px solid ${THEME.palette.primary.main}`,
    backgroundColor: THEME.palette.primary.light,
    color: THEME.palette.primary.main,
  },
  gridInactive: {
    borderLeft: '3px solid transparent',
  },
}));

interface IStatisticsSidebar {
  activeStatistics: StatisticsType;
  setStatistics: (type: StatisticsType) => void;
}

const StatisticsSidebar: React.FC<IStatisticsSidebar> = ({ activeStatistics, setStatistics }) => {
  const classes = useStyles();

  const items = [
    { name: 'MMID Statistics', type: StatisticsType.MMID },
    { name: 'System Statistics', type: StatisticsType.SYSTEM },
  ];

  return (
    <Grid container className={classes.gridContainer}>
      {items.map(item => (
        <Grid
          item
          xs={12}
          key={item.type}
          className={
            activeStatistics === item.type ? classes.gridActive : classes.gridInactive
          }
        >
          <Button
            onClick={() => setStatistics(item.type)}
            className={classes.button}
            variant="text"
          >
            {item.name}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatisticsSidebar;